import React from "react";
import { Input } from "@/components/ui/input";

export default function ScoreIncrement({ value, onChange, code, lang }) {
  const mode = value === undefined || value === "auto" ? "auto"
    : value === null || value === "continuous" ? "continuous" : "custom";
  const invalid = mode === "custom" && !(typeof value === "number" && Number.isFinite(value) && value > 0);
  const id = `s-score-step-${code}`;
  return (
    <div className="mb-4 max-w-lg">
      <label htmlFor={id} className="block text-xs font-medium mb-1">
        {lang === "id" ? "Increment skor" : "Score increment"}
      </label>
      <select id={id} data-testid={id} value={mode}
        aria-describedby={`${id}-help`}
        className="w-full h-9 rounded-md border border-input bg-background px-3 text-sm"
        onChange={(event) => onChange(event.target.value === "auto" ? "auto" : event.target.value === "continuous" ? null : 1)}>
        <option value="auto">{lang === "id" ? "Otomatis (disarankan)" : "Auto (recommended)"}</option>
        <option value="continuous">{lang === "id" ? "Kontinu" : "Continuous"}</option>
        <option value="custom">{lang === "id" ? "Kustom" : "Custom"}</option>
      </select>
      {mode === "custom" && <>
        <label htmlFor={`${id}-custom`} className="block text-xs mt-2 mb-1">
          {lang === "id" ? "Nilai increment" : "Increment value"}
        </label>
        <Input id={`${id}-custom`} data-testid={`${id}-custom`} type="number" step="any" min="0"
          value={value} aria-invalid={invalid} aria-describedby={`${id}-help`}
          onChange={(event) => onChange(event.target.value === "" ? "" : Number(event.target.value))} />
        {invalid && <p role="alert" className="text-xs text-destructive mt-1">
          {lang === "id" ? "Masukkan angka lebih besar dari 0." : "Enter a number greater than 0."}
        </p>}
      </>}
      <p id={`${id}-help`} className="text-[11px] text-muted-foreground mt-1">
        {lang === "id"
          ? "Menentukan perubahan nilai terkecil yang mungkin pada skor ini. Contoh: 1 untuk skor bulat, 0,5 untuk skor yang dapat berubah setiap setengah poin."
          : "Defines the smallest possible change in this score. Example: 1 for whole-number scores, 0.5 for half-point increments."}
      </p>
      <p className="text-[11px] text-muted-foreground mt-1">
        {lang === "id"
          ? "Otomatis menggunakan konfigurasi skoring; jika increment tidak dapat dipastikan, skor diperlakukan sebagai kontinu."
          : "Auto uses the scoring configuration; when an increment cannot be established safely, scores are treated as continuous."}
      </p>
    </div>
  );
}
